import { Tag } from '@ads/components-react';
import type { ComponentType } from 'react';

/**
 * Cabeçalho visual de um card de questão.
 *
 * Exibe ícone, label da questão e, opcionalmente, uma tag com o tipo.
 * Componente compartilhado entre os fluxos exam-management e exam-correction.
 */
export interface QuestionCardHeaderProps {
  /** Texto principal do cabeçalho, ex: "Questão #1" */
  readonly label: string;
  /** Rótulo da Tag de tipo, ex: "Escolha única". Oculto quando nulo ou vazio. */
  readonly tagLabel?: string | null;
  /** Componente de ícone compatível com heroicons (aceita `className`) */
  readonly icon: ComponentType<{ className?: string | undefined }>;
}

export function QuestionCardHeader({ label, tagLabel, icon: Icon }: QuestionCardHeaderProps) {
  return (
    <div className="flex items-center gap-nano border-b-hairline border-ctx-layout-border bg-ctx-layout-spotlight px-xs py-micro">
      <Icon className="size-[18px] shrink-0 text-ctx-content-base" />
      <span className="ts-heading-xs text-ctx-content-title">{label}</span>
      {tagLabel != null && tagLabel !== '' && (
        <Tag label={tagLabel} size="sm" custom={{ text: 'text-nowrap' }} />
      )}
    </div>
  );
}
